import { useState } from "react";

import { FiArrowLeft, FiEdit } from "react-icons/fi";
import EditProjectDetails from "../../modals/projects/EditProjectDetails";
import { Link } from "react-router-dom";

const ProjectDetailsHeader = () => {
  const [showEdit, setShowEdit] = useState(false);

  return (
    <div
      style={{ padding: "15px", background: "#f8f9fa" }}
      className="d-flex justify-content-between align-items-center mb-3"
    >
      {/* Back */}
   <Link className="text-decoration-none"  to="/project-list" >
      <div className="back-link d-flex align-items-center gap-2">
        <FiArrowLeft size={18} />
        <span>Back to List</span>
      </div>
   </Link>

      {/* Edit Button */}
      <button
        className="edit-btn d-flex align-items-center gap-2"
        onClick={() => setShowEdit(true)}
      >
        <FiEdit size={16} />
        <span>Edit Project</span>
      </button>

      <EditProjectDetails
        show={showEdit}
        handleClose={() => setShowEdit(false)}
      />
      <style>
        {`
               .back-link {
  font-size: 14px;
  cursor: pointer;
  color: #374151;
}

.edit-btn {
  background: #f97316;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
}`}
      </style>
    </div>
  );
};

export default ProjectDetailsHeader;
